// Dependencies
import {connect} from 'react-redux';
import {default as colorjs} from 'color';
import SeatSpinner from './SeatSpinner.jsx';

import { addMessage, setSeatInSelection } from '../../redux/seatingplanPageReducer';
import sponsorCodeService from "../../lib/sponsorCodes-service";
import { useContext } from "react";
import { ThemeContext } from "../../components/theme/Theme.jsx";

// Styles

// Helpers

function calculateSelectedStrokeWidth(element) {
	const biggerDimension = element.width > element.height ? element.width : element.height;
	const selectedStrokeWidth = (biggerDimension * 0.1) + 1;
	return selectedStrokeWidth;
}

function createRotateString(element) {
	return (
		`rotate(${element.angle} ` +
		`${element.x + (element.width / 2)} ` +
		`${element.y + (element.height / 2)})`
	);
}

function calculateTextFontSize(element) {
	let fontSize = element.width * 0.6;
	if (element.height < element.width) {
		fontSize = element.height * 0.6;
	}
	return fontSize;
}

function calculateTextX(element, fontSize) {
	let textX;
	if (element.seatNumber >= 10) {
		textX = element.x + ((element.width / 2) - (fontSize * 0.6));
	} else {
		textX = element.x + ((element.width / 2) - (fontSize * 0.3));
	}
	return textX;
}

function calculateTextY(element, fontSize) {
	const textY = element.y + (element.height / 2) + (fontSize * 0.3);
	return textY;
}

function calculateStarPoints(x, y, width, height) {
	let pts = [];
	let n = 0;
	let c = {x: x + (width / 2), y: y + (height / 2)};
	let step = Math.PI / 5;
	//a for loop to calculate the position of the points for the star
	let radius = width >= height ? height : width
	for (let a = -Math.PI / 2; a < 3 * Math.PI / 2; a += step) {
		//The point will be either on the outer circle (radius/3) or on the inner one (radius/3 /2)
		let r = n % 2 === 0 ? radius / 3 : radius / 3 / 2;
		//calculate the x and y of the point
		let x = c.x + r * Math.cos(a);
		let y = c.y + r * Math.sin(a);
		//push the x and the y values to the pts array
		pts.push(x);
		pts.push(y);
		n++
	}

	return pts.join(",");
}

// RenderFunction

function Seat(props) {
	const context = useContext(ThemeContext);
	const e = props.element;
	const handleSeatClicked = props.selectSeat;
	const seatNotAvailableText = context.themeManager.getThemeTextOrHardcodedDefault('seatNotAvailable');
	const handleNotAvailableSeatClicked = () => props.showMessage(seatNotAvailableText);

	const rotateString = createRotateString(e);
	const fontSize = calculateTextFontSize(e);
	const textX = calculateTextX(e, fontSize);
	const textY = calculateTextY(e, fontSize);
	const strokeWidth = props.selected ? calculateSelectedStrokeWidth(e) : 1;
	const ticketUnavailable = !props.seatState || props.seatState.seatTicketState !== 'AVAILABLE'
		|| !props.anyPlSelectable || props.sponsoringData.unavailable
	const seatColor = (ticketUnavailable
		&& !props.selected
		&& !props.selectable) ? 'url(#diagonalHatch)' : props.color;
	const showCross = !props.selected && ((ticketUnavailable && !props.selectable) || props.sponsoringData.excluded);
	const showText = props.selected;
	const hiddenByCategory = !props.categorySelected && !props.selected && !ticketUnavailable;
	const showSpinner = props.seatInProcess === props.seatIdentifier;

	const greyedOut = (!props.selectable && !props.selected
		&& !showCross && !hiddenByCategory && !showSpinner);

	const showStar = !props.sponsoringData.excludePublicSeats && ((!ticketUnavailable && props.selectable
		&& props.seatForRedeemedCodeReserved) || (greyedOut && props.seatForRedeemedCodeReserved));
	const starColor = colorjs(props.color).negate()
	const isClickable = (props.selectable || props.selected)
		&& !hiddenByCategory && !props.seatInProcess && !props.sponsoringData.excluded;

	const clickHandler = isClickable ? handleSeatClicked : (!props.seatInProcess ? handleNotAvailableSeatClicked : null);
    const keyHandler = (event) => {
        if (event.key !== 'Enter') return;
        if (props.seatInProcess) return;
        if (isClickable) {
            handleSeatClicked();
        } else {
            handleNotAvailableSeatClicked();
        }
    };

const selectedStrokeColor = '#575757';
const unselectedStrokeColor = '#757575';
const selectedCircleColor = colorjs(props.color).negate().grayscale();
const selectedCircleCenterX = e.x + (e.width / 2);
const selectedCircleCenterY = e.y + (e.height / 2);
const selectedCircleRadius = (e.width >= e.height ? e.height : e.width) / 12;
const selectedCircleStrokeWidth = (e.width >= e.height ? e.height : e.width) / 10;
return (
	<g onClick={clickHandler} onKeyDown={(event) => keyHandler(event)} transform={rotateString}
		className={isClickable ? 'clickable' : 'not-clickable'} tabIndex={isClickable ? 0 : -1} aria-label={
		(e.block? 'Block: ' + e.block + ', ': '') + 'Reihe: ' + e.rowNumber +  ', Sitz: ' + e.seatNumber +
		(props.cat? ',  Kategorie: ' + props.cat.categoryName : '')}>
		<rect // emulate stroke because of slow perfomance with rotation on mobile
			x={e.x}
			y={e.y}
			width={e.width}
			height={e.height}
			fill={props.selected ? selectedStrokeColor : unselectedStrokeColor}
		/>
		{props.selected &&
			<rect // emulate stroke because of slow perfomance with rotation on mobile
				x={e.x + (strokeWidth / 2)}
				y={e.y + (strokeWidth / 2)}
				width={e.width - strokeWidth}
				height={e.height - strokeWidth}
				fill="#FFF"
			/>
		}

		<rect
			x={e.x + strokeWidth}
			y={e.y + strokeWidth}
			width={e.width - (strokeWidth * 2)}
			height={e.height - (strokeWidth * 2)}
			fill={seatColor}
		/>

		{props.selected &&
			<circle
				cx={selectedCircleCenterX}
				cy={selectedCircleCenterY}
				r={selectedCircleRadius}
				stroke={selectedCircleColor}
				fill={selectedCircleColor}
				strokeOpacity="1"
				fillOpacity="1"
				strokeWidth={selectedCircleStrokeWidth}
			/>
		}

		{showSpinner &&
			<SeatSpinner element={e} seatColor={seatColor}/>
		}

		{false && showText && // das ist erstmal raus
			// weil Texte leider sehr stark auf die perfomance gehen
			// damit man das jeder zeit mal einfach testen kann lasse ich den Code aber hier.
			<text
				x={textX}
				y={textY}
				fontSize={fontSize}
				fill="#000"
			>
				{e.seatNumber}
			</text>
		}



		{showStar &&
			<polygon id="poly" points={calculateStarPoints(e.x, e.y, e.width, e.height)} fill={starColor} stroke="#000"/>
		}

		{greyedOut &&
			<rect
				x={e.x}
				y={e.y}
				width={e.width}
				height={e.height}
				fill="#FFFFFF"
				fillOpacity="0.85"
			/>
		}

		{hiddenByCategory &&
			<rect
				x={e.x}
				y={e.y}
				width={e.width}
				height={e.height}
				fill="#FFFFFF"
				fillOpacity="0.95"
			/>
		}
	</g>
);
}

export function getSeatIdentifier(element) {
	return `{B}${element.block || ''}` +
		`\u241F{R}${element.rowNumber || ''}` +
		`\u241F{S}${element.seatNumber || ''}`;
}

// ------------------------------
// Store Connection
// ------------------------------

const mapStateToProps = (state, props) => {
	const seatIdentifier = getSeatIdentifier(props.element);
	// Sponsor-Codes
	const redeemedSponsorCodeUsages = Object.keys(state.sponsorCodes.codeUsagesPlUuidMap)
	const sponsorReservations = state.sponsorCodes.seatReservations || [];
	const seatForSponsorReserved = sponsorCodeService.isSeatForSponsorReserved(sponsorReservations, seatIdentifier, redeemedSponsorCodeUsages)
	const seatForRedeemedCodeReserved = sponsorCodeService.isSeatForRedeemedSponsorCodeReserved(sponsorReservations, seatIdentifier, redeemedSponsorCodeUsages)

	const seatState = state.seatState.seatInfoMap[seatIdentifier];
	const event = state.event.elements[state.event.selected];
	let cat = null;
	let anyPlSelectable = false;
	let color = '#000000';
	let categorySelected = true;
	if (seatState) {
		cat = event.categories.find(cCat => cCat.categoryUUID === seatState.categoryUUID);
		anyPlSelectable = [cat.standardPriceLevel, ...cat.reducedPriceLevels]
			.some(pl => !pl.accessCodeNeeded || state.accessCodes.plUuidCodeMap[pl.priceLevelUuid]);
		color = cat.color;
		categorySelected = state.categoryFilter.showAll ||
			state.categoryFilter.selectedCategories.indexOf(seatState.categoryUUID) >= 0;
	}
	const sponsoringExcluded = state.sponsorCodes.excludePublicSeats && !seatForRedeemedCodeReserved
	const sponsoringData = {
		excludePublicSeats: state.sponsorCodes.excludePublicSeats,
		granted: seatForRedeemedCodeReserved,
		denied: seatForSponsorReserved,
		excluded: sponsoringExcluded,
		unavailable: sponsoringExcluded || seatForSponsorReserved
	}
	const selectable = anyPlSelectable && state.selectableSeats.indexOf(seatIdentifier) !== -1 && !sponsoringData.unavailable
	const selected = state.selectedSeats.selectedSeats.indexOf(seatIdentifier) !== -1;
	const seatInProcess = state.shoppingCart.seatInProcess;
	return {
		seatIdentifier,
		seatForSponsorReserved,
		seatForRedeemedCodeReserved,
		seatState,
		color,
		selectable,
		selected,
		categorySelected,
		cat,
		seatInProcess,
		anyPlSelectable,
		sponsoringData
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	selectSeat: () => {
		const now = Date.now();
		// 20ms kein Click erkennen
		if (window.LEO_PAN_END_TIME && now - window.LEO_PAN_END_TIME < 20) return;
		dispatch(setSeatInSelection(getSeatIdentifier(ownProps.element)));
	},
	showMessage: (text) => {
		dispatch(addMessage({text: text, type: 'messages'}));
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Seat);
